/// <reference path="../../../../../rcwebmodels/reeferstatus.cs.d.ts" />
import * as React from 'react';
import $ from 'jquery';
import { RCUtils } from './../../RCUtils';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { SpecificBookingDetails } from '../childcomponents/SpecificBookingDetails';
import { SpecificBookingReefersGridData } from '../childcomponents/SpecificBookingReefersGridData';
import DateFormat from 'dateformat';
import forEach from 'lodash/forEach';

var Config: any = require('../../Config.json');

var self;

interface WizardState {
    renderHtml: any;
    BookingDetails: server.BookingDetails;
    BookingReefers: server.BookingSearchDetails;
    //BookingDataForView: server.BookingDataForView;
    BookingViewData: server.BookingViewData;
    rowData: server.bookingReefer[];
    isEdit: boolean;
    tabFrom: number;
    currentTab: number;
    AllBooking: any[];
    BookingCount: number;
    BookingType: any;
    IsOpen: any;
    buttonState: any;
    isViewOnly: boolean;
    formname: any;
}

var emptyBookingDetails: server.BookingDetails = {
    Shipper: '', Consignee: '', ShipperCode: '', POR: '', POL: '', POD: '', VesselETD: null, VesselETA: null, BLNumber: '', ContractParty: '', Consolidation: '',
    Agent: '', VesselCode: '', VoyageNumber: '', Call: '', Forwarder: '', Notify: '', BookingNumber: '', DEL: '', IsVVCModified: false,
    SelectedVesselCD: '',
    SelectedCall: '',
    SelectedVoyage: '',
    ArrSelectedVesselCD: '',
    ArrSelectedCall: '',
    ArrSelectedVoyage: '', userInput: 0, CustomerAccessGroupIDLoaded: '',
    BKCustomer:''
};
var emptyBookingReefers: server.BookingSearchDetails = {
    BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [],  BookingNumber: []
}
var emptyBookingViewData: server.BookingViewData = {
    CACTNotRequired: false, CTRequire: false, CARequire: false, CACTDifferByReefer: false
};
//var emptyBookingDataForView: server.BookingDataForView = {
//    ReeferIds: [], BookingNumber: '', BookedTemperature: '', BookedTemperatureUnit: '', BookedTemperatureMin: '', BookedTemperatureMax: '', HumiditySetPoint: '', VentSettings: '', GensetId: '', CommodityName: '', STCC: '', HSCode: '', ServiceLevel: '',
//    HighValueCargo: false, CargoCareProfile: '', ThirdPartyAccess: '', CACTNotRequired: false, CTRequire: false, CARequire: false, CACTDifferByReefer: false,
//    CTDays: '', CTMaxTemperature: '', PostCTTemperature: '', PostCTTemperatureRange: '', PostCTVentSettings: '', O2SetPoint: '', O2Min: '',
//    O2Max: '', CO2SetPoint: '', CO2Min: '', CO2Max: '', CAGName:''
//};
export class ViewBookingDetails extends React.Component<any, WizardState> {
    constructor(props: any) {
        super(props);
        this.resetAllDetails();
        this.state = {
            renderHtml: '',
            BookingDetails: emptyBookingDetails,
            BookingReefers: emptyBookingReefers,
            //BookingDataForView: emptyBookingDataForView,
            BookingViewData: emptyBookingViewData,
            rowData: [],
            isEdit: false,
            tabFrom: 1,
            currentTab: 1,
            AllBooking: [],
            BookingCount: 0,
            BookingType: 'View Booking',
            IsOpen: 'View',
            buttonState: true,
            isViewOnly: true,
            formname: '',
        };

        self = this;
    }
    dateTypeFormatter(eventDate: Date) {
        //written considering parameter 'eventDate' sent is IST
        var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
        var eventdttm = new Date();
        if (eventDate != null)
            eventdttm = new Date(eventDate.toString());
        var utc = eventdttm.getTime() + (eventdttm.getTimezoneOffset() * 60000);
        var prefDateTime = new Date(new Date(utc).getTime() + (60000 * (parseInt(timeZoneOffset))));
        return prefDateTime;
    }
    resetAllDetails() {
        emptyBookingDetails = {
            Shipper: '', Consignee: '', ShipperCode: '', POR: '', POL: '', POD: '', VesselETD: null, VesselETA: null, BLNumber: '', ContractParty: '', Consolidation: '',
            Agent: '', VesselCode: '', VoyageNumber: '', Call: '', Forwarder: '', Notify: '', BookingNumber: '', DEL: '', IsVVCModified: false,
            SelectedVesselCD: '',
            SelectedCall: '',
            SelectedVoyage: '',
            ArrSelectedVesselCD: '',
            ArrSelectedCall: '',
            ArrSelectedVoyage: '', userInput: 0, CustomerAccessGroupIDLoaded: '',
            BKCustomer:''
        }
        emptyBookingReefers = { BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [],BookingNumber:[] }
    }
    updatemyBookingDimensions() {
        $("#BookingTabsHeight").css('min-height', $(window).height() - 280);
        $("#BookingTabsHeight").css('max-height', $(window).height() - 280);

    }
    componentDidMount() {
        var authRight = RCUtils.CheckAssesRightsOnly('213');
        if (!authRight) { this.props.history.push('/AccessDenied'); } else {
            this.updatemyBookingDimensions();
            window.addEventListener("resize", this.updatemyBookingDimensions.bind(this));
            $("#SubscriptionMenu li").click(function (e) {
                e.preventDefault();
                return false;
            });
            $('.deploymentWizard').find("ul.nav li:nth-child(0)").attr("href", "#menu1");
            //this.getdata(self.props);
            if (self.props.ViewBookingData != null && self.props.ViewBookingData.length > 0 && (self.props.formname == "ReeferStatusGrid" || self.props.formname == "ReeferStatus"))
                this.setState({ AllBooking: self.props.ViewBookingData }, () => { this.GetBookingDetails(self.props.reeferData[0].BookingNumber, self.props.formname); });
            else
                this.setState({ renderHtml: this.dynamicRendering(1) });
        }
    }

    componentWillReceiveProps(nextprops: any) {
        //$('.deploymentWizard').find("ul.nav li:nth-child(0)").attr("href", "#menu1");
        this.resetViewBookingData();
        if (nextprops.ViewBookingData != null && nextprops.ViewBookingData.length > 0 && (nextprops.formname == "ReeferStatusGrid" || nextprops.formname == "ReeferStatus"))
            this.setState({ AllBooking: nextprops.ViewBookingData }, () => { this.GetBookingDetails(nextprops.reeferData[0].BookingNumber, nextprops.formname); });
        else
            this.setState({ renderHtml: this.dynamicRendering(1) });
    }

    resetViewBookingData() {
        this.setState({
            BookingDetails: emptyBookingDetails,
            BookingReefers: emptyBookingReefers,
            //BookingDataForView: emptyBookingDataForView,
            BookingViewData: emptyBookingViewData,
            rowData: [],
            tabFrom: 1,
            currentTab: 1,
            AllBooking: [],
            buttonState: true,
            formname: '',
        });
    }

    GetBookingDetails(BookingNumber: any, FormName: any) {
        var isfound = this.state.AllBooking.filter(x => x.BookingNumber.toLowerCase() == BookingNumber.toLowerCase());
        var BookingInfoDetails = emptyBookingDetails;
        BookingInfoDetails.Shipper = isfound[0].Shipper;
        BookingInfoDetails.Consignee = isfound[0].Consignee;
        BookingInfoDetails.ShipperCode = isfound[0].ShipperCode;
        BookingInfoDetails.POR = isfound[0].POR;
        BookingInfoDetails.POL = isfound[0].POL;
        BookingInfoDetails.POD = isfound[0].POD;
        BookingInfoDetails.VesselETD = isfound[0].VesselETD != null ? DateFormat(new Date(isfound[0].VesselETD), 'mm/dd/yyyy HH:MM:ss') : null;
        BookingInfoDetails.VesselETA = isfound[0].VesselETA != null ? DateFormat(new Date(isfound[0].VesselETA), 'mm/dd/yyyy HH:MM:ss') : null;
        BookingInfoDetails.BLNumber = isfound[0].BLNumber;
        BookingInfoDetails.ContractParty = isfound[0].ContractParty;
        BookingInfoDetails.Consolidation = isfound[0].Consolidation;
        BookingInfoDetails.Agent = isfound[0].Agent;
        BookingInfoDetails.VesselCode = isfound[0].VesselCode;
        BookingInfoDetails.VoyageNumber = isfound[0].VoyageNumber;
        BookingInfoDetails.Call = isfound[0].Call;
        BookingInfoDetails.Forwarder = isfound[0].Forwarder;
        BookingInfoDetails.Notify = isfound[0].Notify;
        BookingInfoDetails.BookingNumber = isfound[0].BookingNumber;
        BookingInfoDetails.DEL = isfound[0].DEL;
        BookingInfoDetails.BKCustomer = isfound[0].BKCustomer;
        if (isfound[0].LifecycleCd == 'L' || isfound[0].LifecycleCd == 'R' || isfound[0].LifecycleCd == 'D' || isfound[0].LifecycleCd == 'P') {
            var departingVVC = isfound[0].DepartingVVC.split('-');
            var depVoyage = departingVVC[0].trim().length > 0 ? departingVVC[0].trim() : '';
            var depCall = departingVVC[1].trim().length > 0 ? departingVVC[1].trim() : '';
            var arrivingVVC = isfound[0].ArrivingVVC.split('-');
            var arrVoyage = arrivingVVC[0].trim().length > 0 ? arrivingVVC[0].trim() : '';
            var arrCall = arrivingVVC[1].trim().length > 0 ? arrivingVVC[1].trim() : '';

            BookingInfoDetails.SelectedVoyage = depVoyage;
            BookingInfoDetails.SelectedCall = depCall;
            BookingInfoDetails.SelectedVesselCD = depVoyage != '' ? isfound[0].VoyageVesselCd : '';
            BookingInfoDetails.ArrSelectedVesselCD = arrVoyage != '' ? isfound[0].VoyageVesselCd : '';
            BookingInfoDetails.ArrSelectedVoyage = arrVoyage;
            BookingInfoDetails.ArrSelectedCall = arrCall;
        }
        var BookingReefersData = emptyBookingReefers;
        BookingReefersData.BookingReefers = this.state.AllBooking.map(x => x.ReeferID).toString();
        BookingReefersData.SelectedBookingReefers = this.state.AllBooking.map(x => x.ReeferID).toString();
        BookingReefersData.ReeferwithUnitID = this.state.AllBooking.map(x => x.ReeferwithUnitID);
        var gridData = [];
        forEach(this.state.AllBooking, function (bookingItem) {
            
            if (bookingItem != "" && bookingItem != null) {

                var item = {
                    action: '', reeferId: bookingItem.ReeferID, cargoCare: bookingItem.CCProfileName, accessCodes: bookingItem.CustomerAccessGroupID, bookedTemperature: bookingItem.BookedTemperature,
                    bookedTemperatureQualifier: bookingItem.BookedTemperatureQualifier, bookedTemperatureMin: bookingItem.BookedTemperatureMin, bookedTemperatureMax: bookingItem.BookedTemperatureMax,
                    humidity: bookingItem.HumiditySetpoint, commodity: bookingItem.Commodity, STCC: bookingItem.STCC, HS: bookingItem.HSCode, gensetId: bookingItem.GensetId, ventSetting: bookingItem.VentSetting,
                    HVFlag: bookingItem.HighValueFlag, serviceLevel: bookingItem.ServiceLevel, CAFlag: bookingItem.CAFlag, O2Setpoint: bookingItem.O2Setpoint, O2SetpointMin: bookingItem.O2SetpointMin, O2SetpointMax: bookingItem.O2SetpointMax,
                    CO2Setpoint: bookingItem.CO2Setpoint, CO2SetpointMin: bookingItem.CO2SetpointMin, CO2SetpointMax: bookingItem.CO2SetpointMax, CTFlag: bookingItem.CTFlag,
                    CTDays: bookingItem.CTDays, USDAMaxTemperature: bookingItem.USDAMaxTemperature, postCTTemperature: bookingItem.PostCTTemperature, postCTTemperatureDeviation: bookingItem.PostCTTemperatureDeviation, postCTVentSetting: bookingItem.PostCTVentSetting,
                    UnitMasterId: bookingItem.UnitMasterID, CustomerAccessGroupIdsStr: '', CAGName: bookingItem.CAGName
                };
                gridData.push(item);
            }
        });
        this.setState({ BookingDetails: BookingInfoDetails, BookingReefers: BookingReefersData, rowData: gridData, buttonState: false, formname: FormName }, () => { this.setState({ renderHtml: this.dynamicRendering(1) }); });
    }
    dynamicRendering(tabPane: number) {
        if (tabPane == 1) {
            this.setState({ isEdit: false });
            return <SpecificBookingDetails
                formState={this.state}
                renderWizardPage={this.renderWizardPage.bind(this)}
            //redirectToDeploymentStatus={this.redirectToDeploymentStatus.bind(this)} 
            />
        }

        else if (tabPane == 4)
            return <SpecificBookingReefersGridData
                formState={this.state}
                viewPopup={true}
                renderWizardPage={this.renderWizardPage.bind(this)}
                isFromViewBooking={true}
            //redirectToDeploymentStatus={this.redirectToDeploymentStatus.bind(this)} 
            />
    }

    setActiveAndInactiveOld(TabToActive: number, TabToInactive: number) {
           if (TabToInactive > 0)
            document.getElementById("atab" + TabToInactive).classList.remove("active");

        document.getElementById("atab" + TabToActive).classList.add("active");
    }
    renderWizardPage(tabPane: number, tabState: any, tabPaneFrom: number) {
        this.setState({ tabFrom: tabPaneFrom });
        this.setActiveAndInactiveOld(tabPane, tabPaneFrom);
        switch (tabPane) {
            case 1:
                var newBookingDetails = emptyBookingDetails;
                newBookingDetails.Shipper = tabState.BookingDetails.Shipper;
                newBookingDetails.Consignee = tabState.BookingDetails.Consignee;
                newBookingDetails.ShipperCode = tabState.BookingDetails.ShipperCode;
                newBookingDetails.POR = tabState.BookingDetails.POR;
                newBookingDetails.POL = tabState.BookingDetails.POL;
                newBookingDetails.POD = tabState.BookingDetails.POD;
                newBookingDetails.VesselETD = tabState.BookingDetails.VesselETD;
                newBookingDetails.VesselETA = tabState.BookingDetails.VesselETA;
                newBookingDetails.BLNumber = tabState.BookingDetails.BLNumber;
                newBookingDetails.ContractParty = tabState.BookingDetails.ContractParty;
                newBookingDetails.Consolidation = tabState.BookingDetails.Consolidation;
                newBookingDetails.Agent = tabState.BookingDetails.Agent;
                newBookingDetails.VesselCode = tabState.BookingDetails.VesselCode;
                newBookingDetails.VoyageNumber = tabState.BookingDetails.VoyageNumber;
                newBookingDetails.Call = tabState.BookingDetails.Call;
                newBookingDetails.Forwarder = tabState.BookingDetails.Forwarder;
                newBookingDetails.Notify = tabState.BookingDetails.Notify;
                newBookingDetails.BookingNumber = tabState.BookingDetails.BookingNumber;
                newBookingDetails.DEL = tabState.BookingDetails.DEL;
                newBookingDetails.SelectedVesselCD = tabState.BookingDetails.SelectedVesselCD;
                newBookingDetails.SelectedCall = tabState.BookingDetails.SelectedCall;
                newBookingDetails.SelectedVoyage = tabState.BookingDetails.SelectedVoyage;
                newBookingDetails.ArrSelectedVesselCD = tabState.BookingDetails.ArrSelectedVesselCD;
                newBookingDetails.ArrSelectedCall = tabState.BookingDetails.ArrSelectedCall;
                newBookingDetails.ArrSelectedVoyage = tabState.BookingDetails.ArrSelectedVoyage;
                newBookingDetails.userInput = tabState.BookingDetails.userInput;
                newBookingDetails.BKCustomer = tabState.BookingDetails.BKCustomer;
                newBookingDetails.IsVVCModified = tabState.BookingDetails.IsVVCModified;
                var newBookingReefersDetails = emptyBookingReefers;
                newBookingReefersDetails.BookingReefers = tabState.SelectedReefer;
                newBookingReefersDetails.SelectedBookingReefers = tabState.ReeferIds;
                newBookingReefersDetails.ReeferwithUnitID = tabState.ReeferwithUnitID;
                this.setState({ BookingDetails: newBookingDetails, BookingReefers: newBookingReefersDetails, rowData: tabState.rowData }, () => { this.setState({ renderHtml: this.dynamicRendering(tabPane), currentTab: tabPane }); });
                break;
            case 4:
                var newBookingReefersDetails = emptyBookingReefers;
                newBookingReefersDetails.BookingReefers = tabState.BookingReefers.BookingReefers;
                newBookingReefersDetails.SelectedBookingReefers = tabState.BookingReefers.SelectedBookingReefers;
                newBookingReefersDetails.ReeferwithUnitID = tabState.BookingReefers.ReeferwithUnitID;

                var emptyBookingViewData: server.BookingViewData = {
                    CACTNotRequired: false, CTRequire: false, CARequire: false, CACTDifferByReefer: false
                };
                var CAFlagCount = 0; var CTFlagCount = 0;
                forEach(tabState.rowData, function (datarow) {
                    if (datarow != null) {
                        if (datarow.CAFlag)
                            CAFlagCount++;
                        if (datarow.CTFlag)
                            CTFlagCount++;
                    }
                });
                if (tabState.rowData.length == CAFlagCount)
                    emptyBookingViewData.CARequire = true;
                else if (tabState.rowData.length == CTFlagCount)
                    emptyBookingViewData.CTRequire = true;
                else if (CAFlagCount == 0 && CTFlagCount == 0)
                    emptyBookingViewData.CACTNotRequired = true;
                else
                    emptyBookingViewData.CACTDifferByReefer = true;

                //emptyBookingDataForView.ReeferIds = newBookingReefersDetails.ReeferwithUnitID;
                this.setState({ BookingReefers: newBookingReefersDetails, BookingDetails: tabState.BookingDetails, BookingViewData: emptyBookingViewData, rowData: tabState.rowData }, () => { this.setState({ renderHtml: this.dynamicRendering(tabPane), currentTab: tabPane }); });
                break;
        }
    }

    backScreen() {
        if (this.state.currentTab == 4) {
            SpecificBookingReefersGridData.BackScreen();
        }
    }

    nextScreen() {
        if (this.state.currentTab == 1) {
            SpecificBookingDetails.NextScreen();
        }
    }

    cancelWizard() {
        this.props.history.goBack();
    }

    static UpdateBookingType(Type: any) {
        self.setState({ BookingType: Type });
    }
    static UpdateButtonStyle(State: any) {
        self.setState({ buttonState: State });
    }
    public render() {
        return <div>

            <div id='ViewBookingWizard'>
                <div>
                    <div className='newBootstrapWizard deploymentWizard' id='EditBooking'>
                        <ul id="SubscriptionMenu" className="nav nav-pills">
                            <li><a href='#' data-bs-toggle="pill" className="nav-link active" id="atab1">Booking Data</a></li>
                            {/*<li><a href='#' data-bs-toggle="pill">Reefers List</a></li>*/}
                            {/*<li><a href='#' data-bs-toggle="pill">Common Reefer Data</a></li>*/}
                            <li><a href='#' data-bs-toggle="pill" className="nav-link" id="atab4">Reefer-Specific Data</a></li>
                        </ul>
                    </div>
                    <div className="tab-content" id='BookingTabsHeight'>
                        {this.state.renderHtml}
                    </div>
                </div>
            </div>


            <div className="modal-footer">

                <div className='float-md-end me-2'>
                    <button type='button' className='btn btn btn-secondary me-2' data-bs-dismiss="modal">Cancel</button>
                    {
                        this.state.currentTab != 1 ? <button type='button' className='btn btn btn-primary' onClick={this.backScreen.bind(this)}>Back</button> : ''
                    }
                    {
                        this.state.currentTab != 4 ?
                            <button type='button' className='btn btn btn-primary' disabled={this.state.buttonState} onClick={this.nextScreen.bind(this)}>Next</button> : ''
                    }
                   

                </div>

            </div>

        </div>;
    }
}